import React from 'react';
import {uniqueId} from 'lodash';
import {Table} from '@/web-components';
import {getColumns} from './TaskReportUtil';

export const getBaseLevelTableHeaderTotals = (tableHeader, currency, customFieldDefinitions) => {
	const columns = getColumns(customFieldDefinitions, tableHeader.totals, currency).map(item => (
		<Table.Column key={'total_' + item.id}>{item.total}</Table.Column>
	));

	return (
		<Table.Rows data={{rows: [columns.length]}} canExpand={false} hasHeader>
			{({tableColumnsProps}) => {
				return (
					<Table.Row {...tableColumnsProps} key={uniqueId('key_')}>
						{columns}
					</Table.Row>
				);
			}}
		</Table.Rows>
	);
};
